import { Flex, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ActionBar, Button, Icon, Text, Time } from '@feathr/components';
import { TimeFormat } from '@feathr/hooks';
import { useUser } from '@feathr/report_components';

import { useEmailConfigurator } from './useEmailConfigurator';

function EmailConfiguratorActionBar(): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { lastSaved, handleSave, isDirty } = useEmailConfigurator();
  const user = useUser();

  return (
    <ActionBar
      left={
        <Flex gap={theme.spacing['2']}>
          <Text.DefaultSemibold>{t('Last saved:')}</Text.DefaultSemibold>
          {lastSaved ? (
            <Time
              format={TimeFormat.longDateTime}
              showTimezone={false}
              timestamp={lastSaved}
              timezone={user.get('timezone')}
            />
          ) : (
            <Text.DefaultRegular>{t('Never')}</Text.DefaultRegular>
          )}
        </Flex>
      }
      right={
        <Button disabled={!isDirty} onClick={handleSave} prefix={<Icon.Save />} type={'primary'}>
          {t('Save changes')}
        </Button>
      }
      usePortal={true}
    />
  );
}

export default EmailConfiguratorActionBar;
